<!-- Edit.vue -->
<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/projects">Projects</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="project.deleted_at" class="mb-6" @restore="restore">This project has been deleted.</trashed-message>

    <ProjectForm
      :form="form"
      :organizations="organizations"
      :isAdmin="isAdmin"
      :showOrganizationField="true"
      :submit="update"
    >
      <template #actions>
        <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/projects">Go back</Link>
        <button v-if="!project.deleted_at && isAdmin" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete project</button>
        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update project</loading-button>
      </template>
    </ProjectForm>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import ProjectForm from '@/Pages/Projects/ProjectForm.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import TrashedMessage from '@/Shared/TrashedMessage.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    ProjectForm,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    project: Object,
    organizations: Array,
    loggedUser: Object,

  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.project.name,
        cleanup_hours: this.project.cleanup_hours,
        organization_id: this.project.organization_id,
      }),
    }
  },
  computed: {
    isAdmin() {
      return this.loggedUser.type === 'ADMIN'
    }
  },
  methods: {
    update() {
      this.form.put(`/projects/${this.project.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this project with all related users, streams, comments, recordings?')) {
        this.$inertia.delete(`/projects/${this.project.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this project?')) {
        this.$inertia.put(`/projects/${this.project.id}/restore`)
      }
    },
  },
}
</script>
